export default __webpack_public_path__ + "static/media/poppins-semibold.03280596.woff2";